// Schedule the next calendar day after success; retry only unfinished/failed work.
export function startColorSyncScheduler(sync) {
  let timer;
  let running = false;
  let stopped = false;
  let nextCheck = 0;

  const check = async () => {
    if (stopped || running || Date.now() < nextCheck ||
        document.visibilityState === "hidden" || navigator.onLine === false) return;
    running = true;
    window.clearTimeout(timer);
    let succeeded = false;
    try {
      succeeded = (await sync()) !== false;
    } catch (error) {
      console.error("[ColorSync] Scheduled sync failed; retrying in one minute", error);
    } finally {
      running = false;
      if (!stopped) {
        const now = new Date(Date.now());
        nextCheck = succeeded
          ? new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime()
          : Date.now() + 60000;
        timer = window.setTimeout(check, Math.max(0, nextCheck - Date.now()));
      }
    }
  };
  window.addEventListener("online", check);
  window.addEventListener("focus", check);
  document.addEventListener("visibilitychange", check);
  check();
  return () => {
    stopped = true;
    window.clearTimeout(timer);
    window.removeEventListener("online", check);
    window.removeEventListener("focus", check);
    document.removeEventListener("visibilitychange", check);
  };
}
